import React from 'react';
import { Layout as AntLayout } from 'antd';
import { useLocation } from 'react-router';
import cn from 'classnames';
import some from 'lodash/some';

import Sidebar from '@components/layout/Sidebar';

import { authRoutes } from '../../routes';

const { Content } = AntLayout;

function Layout({ className, children }) {
  const location = useLocation();
  const hideLayout = some(authRoutes, ({ path }) => path === location.pathname);

  return (
    !hideLayout && (
      <AntLayout className="layout" hasSider>
        <Sidebar />
        <AntLayout>
          <Content className={cn('layout__main main', className)}>
            {children}
          </Content>
        </AntLayout>
      </AntLayout>
    )
  );
}

export default Layout;
